export default __webpack_public_path__ + "static/media/w04.054ecb35.svg";